import React, { useEffect, useState } from "react";
import "../css/networkList.css";
import IndividualEventCard from "./individualEventCard.js";
import { BASE_URL } from "../constants";
import "../css/eventsList.css"; // Ensure the correct path is used for your CSS file
import { useLanguage } from "../components/Language.js";

function ReceivedInvites({ username, onClose }) {
    const [invites, setInvites] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedEventId, setSelectedEventId] = useState(null);

    const {language} = useLanguage();

    const translations = {
        en: {
            nameInvites: `${username}'s invites`,
            event: "Event: ",
            from: "From: ",
            message: "Message: ",
            viewEvent: "View Event",
            noInvitesReceived: "No invites received",
            loading: "Loading...",
            close: "Close",
               
        },

        gd: {
            nameInvites: `Cuiridhean ${username}`,
            event: "Tachartas",
            from: "Bho",
            message: "Teachdaireachd",
            viewEvent: "Thoir sùil air an tachartas",
            noInvitesReceived: "Cha d' fhuaireadh cuiridhean sam bith",
            loading: "Luchdachadh...",
            close: "Dùin",
            
        },
    };

    const handleViewEvent = (eventId) => {
        setSelectedEventId(eventId);
    };

    const handleCloseEventCard = () => {
        setSelectedEventId(null);
    };

    useEffect(() => {
        const fetchInvites = async () => {
            try {
                const response = await fetch(`${BASE_URL}/api/get_received_invites/${username}/`);
                if (response.ok) {
                    const data = await response.json();
                    setInvites(data.invites);
                } else {
                    console.error("Failed to fetch invites");
                }
            } catch (error) {
                console.error("Error fetching invites:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchInvites();
    }, [username]);

    return (
        <div className="network-list-overlay">
            <h3>{translations[language].nameInvites}</h3>
            {isLoading ? (
                <p>{translations[language].loading}</p>
            ) : invites.length > 0 ? (
                <ul>
                    {invites.map((invite, index) => (
                        <li key={index}>
                            <strong>{translations[language].event}</strong> {invite.event_title} <br />
                            <strong>{translations[language].from}</strong> {invite.invited_by} <br />
                            <strong>{translations[language].message}</strong> {invite.message || "No message provided"} <br />
                            <button onClick={() => handleViewEvent(invite.event_id)}>
                            {translations[language].viewEvent}
                            </button>
                        </li>
                    ))}
                </ul>
            ) : (
                <p>{translations[language].viewEvent}</p>
            )}
            <button onClick={onClose}>{translations[language].close}</button>

            {selectedEventId && (
            <div className="event-card-overlay">
                <IndividualEventCard
                eventId={selectedEventId}
                onClose={handleCloseEventCard}
                />
            </div>
            )}
        </div>
    );
}

export default ReceivedInvites;
